export default {
  page_title: 'SolvV',
  hello: 'Hello!',
  delete: 'Delete',
  edit: 'Edit',
  search: 'Search',
  confirm: 'Confirm',
  next: 'Next',
  batchUpload: 'Batch Upload',
  save_as_draft: 'Save as Draft',
  basic_information: 'Basic Information',
  additional_information: 'Additional Information',
  dignose: 'Diagnose',
  knowledge_base: 'Knowledge Base',
  tag: 'Tag',
  analyse: 'Analyse',
  template: 'Template',
  flow: 'Flow (Coming soon)',
  machine: 'Machine',
  issues: 'Issues',
  causes: 'Causes',
  routines: 'Routines',
  menu_diagnose: 'Diagnose',
  menu_knowledge_base: 'Knowledge Base',
  menu_insights: 'Insights',
  dashboard_welcome: 'What do you want to solve today?',
  dashboard_dignose: 'Diagnose an Issue',
  dashboard_knowledge_base: 'Knowledge Base',
  dashboard_analyse: 'Insights',
  knowledge_base_suggestion_view: 'User Suggestions Review',
  template_add_new: 'Add New Template',
  template_existing: 'Existing Templates',
  flow_add_new: 'Add New Flow',
  flow_existing: 'Existing Flows',
  machine_add_new: 'Add New Machine',
  machine_existing: 'Existing Machines',
  machine_all_machines: 'All Machines',
  machine_name: 'Machine Name',
  alias: 'Alias',
  location: 'Location',
  service_number: 'Service Number',
  unique_id: 'Unique ID',
  machine_type: 'Machine Type',
  manufacturer: 'Manufacturer',
  serial_number: 'Serial Number',
  construction_date: 'Construction Date',
  acceptance_date: 'Acceptance Date',
  template_information: 'Template Information',
  template_type: 'Template Type',
};
